import ConfirmModal from '../../components/util/ConfirmModal'
import { useModal } from '../../contexts/ModalContext'

export default function useConfirm() {
  const { openModal, closeModal } = useModal()

  return function confirm({
    title,
    message,
    confirmation,
    color = 'primary',
    onConfirm,
  }: {
    title: string
    message: string | JSX.Element
    confirmation: string
    color?: 'error' | 'warning' | 'primary'
    onConfirm: () => void
  }) {
    const id = 'confirm'
    openModal(
      id,
      <ConfirmModal
        title={title}
        message={message}
        confirmation={confirmation}
        onClose={() => closeModal(id)}
        onConfirm={onConfirm}
        color={color}
      />,
    )
  }
}
